import type React from 'react';
import { TildelAnsvarligSelector } from './TildelAnsvarligSelector';
import { TildelAnsvarligModal } from './TildelAnsvarligModal';
import type { WithSubComponents } from '@forvalter/utils/TypeScriptUtils';

type TildelAnsvarligSubcomponents = {
    Selector: typeof TildelAnsvarligSelector;
    Modal: typeof TildelAnsvarligModal;
};

export const TildelAnsvarlig: WithSubComponents<
    React.FC,
    TildelAnsvarligSubcomponents
> = () => {
    return null;
};

TildelAnsvarlig.Selector = TildelAnsvarligSelector;
TildelAnsvarlig.Modal = TildelAnsvarligModal;
